import { Component, ViewChild } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { NgbCollapseModule, NgbDateParserFormatter, NgbDatepicker, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ComboService } from '../Model/Combo/combo.service';
import { SessionService } from '../Util/Session/session.service';
import { CommonService } from '../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { DailyAttendanceService } from '../Model/WebAttendance/daily-attendance.service';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { Subject } from 'rxjs';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { DownloadSampleService } from '../Model/DownloadSample/download-sample.service';

@Component({
  selector: 'app-daily-attendance2',
  standalone: true,
  imports: [LoaderComponent, CommonModule, FormsModule, NgSelectModule, DataTablesModule, NgbCollapseModule, NgbDatepickerModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './daily-attendance2.component.html',
  styleUrl: './daily-attendance2.component.scss'
})
export class DailyAttendance2Component {

  isDisabled: boolean = false;
  isCollapsed: boolean = false;
  maxDate: any;
  allSelect: boolean = false;

  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;
  AttendanceTypes = [] as any;
  TablesDatas: any[] = [];
  Shifts = [] as any;
  Duties = [] as any;
  DutyForEmployee = [] as any;
  Designations = [] as any;
  Zones = [] as any;

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private combo: ComboService,
    private session: SessionService,
    protected common: CommonService,
    private toast: ToastService,
    private attendance: DailyAttendanceService,
    private dateFormat: CustomDateParserFormatter,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private download: DownloadSampleService
  ) {
    const today = new Date();
    this.maxDate = {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate()
    };
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Zone');
    this.ComboLoad('Attendance Type')
    this.ComboLoad('Duty');
    this.ComboLoad('Shift');
    this.ComboLoad('Designation');
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Filter = {
    BranchId: null,
    ZoneId: null,
    ClientID: null,
    SiteID: [] as any,
    UserId: null,
    Date: null as any,
    DateObj: null as any,
    AttendanceType: null,
    ForDate: null,
    SelectAttendanceType: null,
    MarkAttendanceType: null,
    MarkShift: null,
    MarkDuty: null,
    InTime: "",
    OutTime: ""
  }

  FillCombo(Combotype: String) {
    this.isDisabled = true;
    if (Combotype === 'Zone') {
      this.Clients = [];
      this.Sites = [];
      this.Filter.ClientID = null;
      this.Filter.SiteID = [];
    } else if (Combotype === 'Client') {
      this.Clients = [];
      this.Sites = [];
      this.Filter.ClientID = null;
      this.Filter.SiteID = [];
    } else if (Combotype === 'Site') {
      this.Sites = [];
      this.Filter.SiteID = [];
    }
    this.attendance.FillCombo({
      SelectType: Combotype,
      ZoneId: this.Filter.ZoneId,
      ClientID: this.Filter.ClientID
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Zone') {
          this.Zones = response.ComboLoad;
        } else if (Combotype == 'Client') {
          this.Clients = response.Table;
        } else if (Combotype == 'Site') {
          this.Sites = response.Table;
        }
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    })
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    // if (Combotype === 'Branch') {
    //   this.Clients = [];
    //   this.Sites = [];
    //   this.Filter.ClientID = null;
    //   this.Filter.SiteID = null;
    // } else if (Combotype === 'Client') {
    //   this.Sites = [];
    //   this.Filter.SiteID = null;
    // } else if (Combotype === 'Site') {
    //   this.Filter.SiteID = null;
    // }

    this.combo.ComboLoad({
      'Combotype': Combotype,
      'ZoneId': (Combotype == 'Client') ? this.Filter.ZoneId : 0,
      'BranchId': (Combotype == 'Client') ? this.Filter.BranchId : 0,
      'ClientId': (Combotype == 'Site') ? this.Filter.ClientID : 0,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.Branchs = response.ComboLoad;
        } else if (Combotype == 'Zone') {
          this.Zones = response.ComboLoad;
        } else if (Combotype == 'Client') {
          this.Clients = response.ComboLoad;
        } else if (Combotype == 'Site') {
          this.Sites = response.ComboLoad;
        } else if (Combotype == 'Attendance Type') {
          this.AttendanceTypes = response.ComboLoad;
        } else if (Combotype == 'Shift') {
          this.Shifts = response.ComboLoad;
        } else if (Combotype == 'Duty') {
          this.Duties = response.ComboLoad;
          this.DutyForEmployee = response.ComboLoad;
        } else if (Combotype == 'Designation') {
          this.Designations = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  LoadAttendance() {
    if (this.Filter.Date === null || this.Filter.Date === '') {
      this.toast.show({ message: "Please select Date", type: toastTypeEnum.warning });
      return;
    }
    if (this.Filter.ZoneId === null || this.Filter.ZoneId === '') {
      this.toast.show({ message: "Please select Zone", type: toastTypeEnum.warning });
      return;
    }
    if (this.Filter.ClientID === null || this.Filter.ClientID === '') {
      this.toast.show({ message: "Please select Client", type: toastTypeEnum.warning });
      return;
    }
    // if (this.Filter.SiteID === null || this.Filter.SiteID === '') {
    //   this.toast.show({ message: "Please select Site", type: toastTypeEnum.warning });
    //   return;
    // }
    try {
      this.isDisabled = true;
      this.attendance.DailyAttendance({
        SelectType: 'DA',
        AttendanceDate: this.dateFormat.format(this.Filter.Date),
        ClientID: this.Filter.ClientID,
        ZoneID: this.Filter.ZoneId,
        SiteID: this.Filter.SiteID.length > 0 ? this.Filter.SiteID.join(',') : ''
      }).subscribe({
        next: (response) => {
          if (response.Table) {
            if (response.Table[0].MessageType === "ERROR" && response.Table[0].ERRORCODE == 100) {
              this.download.exportToExcelWithProgress(response.Table, 'Attendance Details');
              this.toast.show({ message: response.Table[0].Message, type: toastTypeEnum.warning });
              this.isDisabled = false;
              return;
            } else if (response.Table[0].MessageType === "ERROR") {
              this.toast.show({ message: response.Table[0].Message, type: toastTypeEnum.warning });
              this.isDisabled = false;
              return;
            } else {
              this.TablesDatas = response.Table1;
              for (let data of this.TablesDatas) {
                if (data.DailyAttendanceInOutID == 0) {
                  data.selected = true;
                }
                if (data.InTime === null) {
                  data.InTime = "00:00"
                } else {
                  data.InTime = data.InTime.split(" ")[1].split(":")[0] + ":" + data.InTime.split(" ")[1].split(":")[1];
                }

                if (data.OutTime === null) {
                  data.OutTime = "00:00"
                } else {
                  data.OutTime = data.OutTime.split(" ")[1].split(":")[0] + ":" + data.OutTime.split(" ")[1].split(":")[1];
                }
                data.InDate = this.Filter.Date;
                data.OutDate = this.dateFormat.format(this.Filter.Date);
              }
              if (this.dtElement) {
                this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                  dtInstance.destroy();
                  this.dtTrigger.next(null);
                });
              }
              this.isDisabled = false;
            }
          }
          else {
            this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning });
            this.isDisabled = false;
          }
        }
      })
    } catch (error) {
      this.isDisabled = false;
      console.error('Error occurred:', error);
    }
  }

  clearAttendanceMark() {
    for (let data of this.TablesDatas) {
      data.selected = false;
    }
  }

  selectAttendanceType(AttendanceType: null) {
    for (let data of this.TablesDatas) {
      if (data.AttendanceRemark === AttendanceType) {
        data.selected = true;
      } else {
        data.selected = false;
      }
    }
  }

  markAttendanceType(AttendanceType: any) {
    // for (let data of this.TablesDatas) {
    //   data.AttendanceRemark = AttendanceType;
    //   data.selected = true;
    // }

    for (let data of this.TablesDatas) {
      if (data.selected) {
        data.AttendanceRemark = AttendanceType;
      }
    }
  }

  markShift(Shift: any) {
    for (let data of this.TablesDatas) {
      if (data.selected) {
        if (data.ShiftMasterID == null || data.ShiftMasterID == '' || data.ShiftMasterID == 0) {
          data.ShiftMasterID = Shift;
        }
      }
    }
  }

  markDuty(Duty: any) {
    for (let data of this.TablesDatas) {
      if (data.selected) {
        if (data.DutyMasterID == null || data.DutyMasterID == '') {
          for (let duty of this.Duties) {
            if (duty.DutyMasterID == Duty) {
              data.DutyMasterID = Duty;
              data.selected = true;
            }
          }
        }
      }
    }
  }

  selectAll(event: any) {
    const isChecked = event.target.checked;
    for (let data of this.TablesDatas) {
      data.selected = isChecked;
    }
  }

  selectRow(event: any, shift: any) {
    shift.selected = event.target.checked;
  }

  loadDuty(DesignationMasterID: number, rowIndex: number) {
    this.combo.ComboLoad({
      'Combotype': "Duty",
      'designationid': DesignationMasterID
    }).subscribe({
      next: (response) => {
        this.Duties = response.ComboLoad;
      }
    })
    this.TablesDatas[rowIndex].DutyMasterID = null;
  }

  shiftChange(index: number, shiftMasterID: number) {
    const selected = this.Shifts.find((site: { ShiftMasterID: number; }) => site.ShiftMasterID == shiftMasterID);
    this.TablesDatas[index].InTime = selected ? selected.InTime : "00:00";
    this.TablesDatas[index].OutTime = selected ? selected.OutTime : "00:00";
    if (selected.RotationalShift) {
      // Convert the OutDate to a JavaScript Date object
      let outDateObj = new Date(
        this.Filter.Date.year,
        this.Filter.Date.month - 1, // Adjust for 0-indexed month
        this.Filter.Date.day
      );
      outDateObj.setDate(outDateObj.getDate() + 1);

      this.TablesDatas[index].OutDate = {
        year: outDateObj.getFullYear(),
        month: outDateObj.getMonth() + 1,
        day: outDateObj.getDate()
      };

      this.TablesDatas[index].OutDate = this.dateFormat.format(this.TablesDatas[index].OutDate);
    } else {
      this.TablesDatas[index].OutDate = this.dateFormat.format(this.Filter.Date);
    }

  }

  validateInput(event: any) {
    let value = event.target.value;

    // Remove invalid characters (keep digits and dot only)
    value = value.replace(/[^0-9.]/g, '');

    // Only allow one dot
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts[1];
    }

    // Limit to two digits after decimal
    if (parts[1]) {
      parts[1] = parts[1].slice(0, 2);
      value = parts[0] + '.' + parts[1];
    }

    event.target.value = value;
  }

  datechange() {
    this.Filter.DateObj = this.dateFormat.format(this.Filter.Date);
  }

  async Save() {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Are you Sure want to save?'

    modalRef.result.then((result: any) => {
      if (result) {
        this.InsertUpdate();
      }
    }).catch(() => { });
  }

  InsertUpdate() {
    const SelectedData = this.TablesDatas.filter(data => data.selected === true);

    if (this.TablesDatas.length !== 0 && SelectedData.length === 0) {
      this.toast.show({ message: 'Select any data to continue', type: toastTypeEnum.warning });
      return
    }

    if (SelectedData.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return;
    }

    for (let i = 0; i < SelectedData.length; i++) {
      for (let j = i + 1; j < SelectedData.length; j++) {
        if ((SelectedData[i].EmpCode === SelectedData[j].EmpCode) && (SelectedData[i].DesignationMasterID === SelectedData[j].DesignationMasterID) && (SelectedData[i].DutyMasterID === SelectedData[j].DutyMasterID) && (SelectedData[i].ShiftMasterID === SelectedData[j].ShiftMasterID)) {
          this.toast.show({ message: `Duplicate record found for ${SelectedData[i].FullName}. Please ensure each employee has a unique Designation, Duty and Shift`, type: toastTypeEnum.danger });
          return;
        }
      }
    }

    const AttendanceDetail = SelectedData.map(data => {
      return {
        DailyAttendanceInOutId: data.DailyAttendanceInOutID,
        EmpMasterId: data.EmpMasterID,
        BranchId: data.BranchMasterID,
        SiteId: data.SiteMasterId,
        DesignationId: data.DesignationMasterID,
        DutyId: data.DutyMasterID,
        ShiftMasterId: data.ShiftMasterID,
        AttendanceRemark: data.AttendanceRemark,
        BillableOT: Math.floor(parseFloat(data.BillableOT) * 100) / 100,
        NonBillableOT: Math.floor(parseFloat(data.NonBillableOT) * 100) / 100,
      }
    })

    const AttendanceDataUpdate = {
      SelectType: "I",
      AttendanceDate: this.dateFormat.format(this.Filter.Date),
      MaxConnectToSelfAttendance: AttendanceDetail
    }

    for (let i = 0; i < SelectedData.length; i++) {
      if (SelectedData[i].DesignationMasterID == null || SelectedData[i].DutyMasterID == null || SelectedData[i].ShiftMasterID == null) {
        this.toast.show({ message: `Select All Fields for EmpCode  ${SelectedData[i].EmpCode}`, type: toastTypeEnum.warning });
        return;
      }
    }

    for (let i = 0; i < SelectedData.length; i++) {
      if (SelectedData[i].BillableOT < 0 || SelectedData[i].BillableOT > 24) {
        this.toast.show({ message: `OT should be in between 0 to 24 for employee code ${SelectedData[i].EmpCode}`, type: toastTypeEnum.warning });
        return;
      }
    }

    for (let i = 0; i < SelectedData.length; i++) {
      if (SelectedData[i].NonBillableOT < 0 || SelectedData[i].NonBillableOT > 24) {
        this.toast.show({ message: `OT should be in between 0 to 24 for employee code  ${SelectedData[i].EmpCode}`, type: toastTypeEnum.warning });
        return;
      }
    }

    this.isDisabled = true;
    this.attendance.Attendance_Save(AttendanceDataUpdate).subscribe(
      data => {
        if (data.ESS_SaveAttendance_MaxConnect[0].MessageType == "SUCCESS") {
          this.toast.show({ message: "Data Uploaded Successfully", type: toastTypeEnum.success });
          this.isDisabled = false;
          this.TablesDatas = [];
          if (this.dtElement.dtInstance) {
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next(null);
            });
          }
          this.Filter.Date = null;
          this.Filter.BranchId = null;
          this.Filter.ZoneId = null;
          this.Filter.ClientID = null;
          this.Filter.SiteID = [];
        }
        else {
          this.toast.show({ message: data.ESS_SaveAttendance_MaxConnect[0].Message, type: toastTypeEnum.warning });
          this.isDisabled = false;
        }
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      });
  }

  clear() {
    this.TablesDatas = [];
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } catch (e) {}
  }

}
